import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getCurrentFamilies
} from '../api/familyAPI';

export interface FamilyState {
  families: any[];
  status: 'idle' | 'loading' | 'failed';
  error: any;
}

const initialState: FamilyState = {
  families: [],
  status: 'idle',
  error: null,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
const getCurrentFamiliesAsync = createAsyncThunk(
  'profile/getCurrentFamilies',
  async (familiesData, { rejectWithValue }) => {
    try {
      const response: any = await getCurrentFamilies();
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    } catch (err: any) {
      return rejectWithValue({
        name: err.name,
        message: err.message,
      });
    }
  },
);

export const profileSlice = createSlice({
  name: 'family',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentFamiliesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getCurrentFamiliesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.families = action.payload.families;
        state.error = null;
      })
      .addCase(getCurrentFamiliesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.families = [];
        state.error = action.payload;
      })
  },
});

export default profileSlice.reducer;

export {
  getCurrentFamiliesAsync,
};